module.exports = __webpack_public_path__ + "static/media/tee.d2a13dfc.png";